
const MIN_SIZE = 8
const MAX_SIZE = 16
const SIZE_MULTIPLICATOR = 4

export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    styles() {
      const size = Math.min(
        MIN_SIZE + SIZE_MULTIPLICATOR * this.index,
        MAX_SIZE,
      )

      return {
        width: `${size}px`,
        height: `${size}px`,
      }
    },

    classes() {
      return [this.selected ? 'bg-primary' : 'bg-neutral']
    },
  },
}
